import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BandejaPrincipalComponent } from './pages/bandeja-principal/bandeja-principal.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ResultadoComponent } from './pages/resultado/resultado.component';

const routes: Routes = [
  { path: 'bandejaprincipal/:id/:rut', component: BandejaPrincipalComponent },
  { path: 'resultado/:tipo', component: ResultadoComponent },
  { path: 'notfound', component: NotFoundComponent },
  { path: 'errorcompatibility', component: NotFoundComponent },
  { path: '**', pathMatch: 'full', redirectTo: '/notfound' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
